var screening = {
  name: 'screening',
  data: [{}],
  onlyTemplate: {
    pro: ''
  }
};
export default screening;